import { Dolezitost as DolezitostDto } from 'elegislativa-frontend-ts-axios';

enum DolezitostEnum {
  VYSSIA='VYSSIA',
  STREDNA='STREDNA',
  NIZSIA='NIZSIA',
}

interface Dolezitost {
  hodnota: DolezitostEnum,
  nazov: string
}

function mapDolezitost(dolezitost: DolezitostDto): Dolezitost | null {
  if (!dolezitost) {
    return null;
  }
  return {
    hodnota: DolezitostEnum[dolezitost.hodnota],
    nazov: dolezitost.nazov,
  };
}

function dolezitostNazov(dolezitostEnum: DolezitostEnum): string {
  switch (dolezitostEnum) {
    case DolezitostEnum.VYSSIA:
      return 'Vyššia dôležitosť';
    case DolezitostEnum.STREDNA:
      return 'Stredná dôležitosť';
    case DolezitostEnum.NIZSIA:
      return 'Nižšia dôležitosť';
    default:
      throw new Error('Unrecognized dolezitost value.');
  }
}

export {
  DolezitostEnum, Dolezitost, mapDolezitost, dolezitostNazov,
};
